import { useEffect } from "react";
import { useLocation } from "wouter";
import { useSubscription } from "../contexts/subscription";

export default function CheckoutSuccess() {
  const [, navigate] = useLocation();
  const { refresh } = useSubscription();

  useEffect(() => {
    // Refresh subscription status, then redirect to dashboard after a moment
    refresh().then(() => {
      setTimeout(() => navigate("/"), 3000);
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0e1a] flex items-center justify-center font-mono">
      <div className="text-center max-w-md px-4">
        <div className="text-6xl mb-6">🎉</div>
        <h1 className="text-[#00ff00] text-2xl font-bold tracking-wider mb-3">
          WELCOME TO PRO!
        </h1>
        <p className="text-white/60 text-sm leading-relaxed mb-6">
          Your CPL Prep Pro subscription is now active. All sections, exam simulations,
          and analytics are unlocked. Happy studying — you've got this.
        </p>
        <p className="text-white/30 text-xs">Redirecting to your dashboard...</p>
        <button
          onClick={() => navigate("/")}
          className="mt-4 px-6 py-2 border border-[#00ff00]/30 text-[#00ff00] text-sm rounded hover:bg-[#00ff00]/10 transition-colors"
        >
          GO TO DASHBOARD
        </button>
      </div>
    </div>
  );
}
